import styled from '../node_modules/.pnpm/@linaria_react@3.0.0-beta.15_react@17.0.2/node_modules/@linaria/react/esm/styled.js';
import { getPresets } from '@indriver/vandermeer';
import preset from './preset.js';

var style = getPresets(preset, {});
var GRIPPER_HEIGHT = '20px';
var Backdrop = /*#__PURE__*/styled("div")({
  name: "Backdrop",
  class: "by0mbp6",
  vars: {
    "by0mbp6-0": [function (_ref) {
      var position = _ref.position;
      return position;
    }],
    "by0mbp6-1": [function (_ref2) {
      var opacity = _ref2.opacity,
          gripped = _ref2.gripped;
      return opacity || !gripped ? 'block' : 'none';
    }],
    "by0mbp6-2": [function (_ref3) {
      var zIndex = _ref3.zIndex;
      return zIndex;
    }],
    "by0mbp6-3": [function (_ref4) {
      var opacity = _ref4.opacity,
          gripped = _ref4.gripped;
      return "rgba(0, 0, 0, " + (gripped ? opacity : 0.5) + ")";
    }]
  }
});
var Box = /*#__PURE__*/styled("div")({
  name: "Box",
  class: "bbosj7q",
  vars: {
    "bbosj7q-0": [function (_ref5) {
      var position = _ref5.position;
      return position;
    }],
    "bbosj7q-1": [style.background],
    "bbosj7q-2": [style.color],
    "bbosj7q-3": [function (_ref6) {
      var zIndex = _ref6.zIndex;
      return zIndex;
    }],
    "bbosj7q-4": [style.fontFamily],
    "bbosj7q-5": [function (_ref7) {
      var transition = _ref7.transition;
      return transition;
    }],
    "bbosj7q-6": [function (_ref8) {
      var offsetY = _ref8.offsetY;
      return "translateY(" + offsetY + ")";
    }],
    "bbosj7q-7": [function (_ref9) {
      var gripped = _ref9.gripped;
      return gripped ? GRIPPER_HEIGHT : '4px';
    }],
    "bbosj7q-8": [function (_ref10) {
      var staticHeight = _ref10.staticHeight;
      return staticHeight ? '96%' : 'auto';
    }]
  }
});
var ResetButton = /*#__PURE__*/styled("button")({
  name: "ResetButton",
  class: "rwjneiu"
});
var GripperBox = /*#__PURE__*/styled(ResetButton)({
  name: "GripperBox",
  class: "gfanq3j",
  vars: {
    "gfanq3j-0": [function () {
      return "calc(" + GRIPPER_HEIGHT + " * 2)";
    }],
    "gfanq3j-1": [style.gripperBackground]
  }
});

export { Backdrop, Box, GRIPPER_HEIGHT, GripperBox, ResetButton };


require('../../styles-linaria/bottom-sheet/bottom-sheet.styles.css');
